// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CreateMapByObj } from '../CreateMapByObjectUtils';
export var AccountType;
(function (AccountType) {
    AccountType[AccountType["SingleCCY"] = 0] = "SingleCCY";
    AccountType[AccountType["MultiAsset"] = 1] = "MultiAsset";
    AccountType[AccountType["ClosedFund"] = 2] = "ClosedFund";
    AccountType[AccountType["OpenedFund"] = 3] = "OpenedFund";
})(AccountType || (AccountType = {}));
export const AccountTypeMap = CreateMapByObj(AccountType);
export function getAccountTypeStr(value) {
    return AccountTypeMap[value] || AccountTypeMap[AccountType.SingleCCY];
}
